import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { BlankPage } from '../../Components/Layout/Page';
import { useEffect, useState } from 'react';
import LoadingSpinner from '@cb/solaris-react/Components/Loading/LoadingSpinner';
import useUserService from '../../Hooks/UseUserService';
import { useLogout } from '../../Hooks/UseLogout';
import { useTokenData } from '../../Hooks/UseTokenStore';
export default function Logout(props) {
    const userService = useUserService();
    const { tokenData } = useTokenData();
    const [formEl, setFormEl] = useState(null);
    const { clearCredentials } = useLogout();
    useEffect(() => {
        if (formEl) {
            clearCredentials();
            formEl.submit();
        }
    }, [clearCredentials, formEl]);
    const fullLogoutUrl = userService.getAuthServiceLogoutUrl(tokenData?.id_token);
    const logoutUrlWithoutSearch = fullLogoutUrl.origin + fullLogoutUrl.pathname;
    return (_jsxs(BlankPage, { pageTitle: props.defaultPageTitle, children: [_jsx(LoadingSpinner, { overlay: true, text: "Logging out..." }), _jsxs("form", { ref: setFormEl, method: "post", action: logoutUrlWithoutSearch, style: { visibility: 'hidden' }, children: [_jsx("input", { type: "hidden", name: "id_token_hint", value: tokenData?.id_token }), _jsx("input", { type: "hidden", name: "post_logout_redirect_uri", value: window.location.origin + '/' }), _jsx("input", { type: "submit", value: "Logout" })] })] }));
}
//# sourceMappingURL=Logout.js.map